import {
  BirdviewSection,
  BirdviewTileKey,
  DashboardTileTone,
} from '../DashboardBirdview.constants'

import EmailIcon from '../../../icons/email.svg'
import ProvidersIcon from '../../../icons/providers.svg'
import ServiceRequestIcon from '../../../icons/service-request.svg'
import TaskIcon from '../../../icons/task.svg'

export const BirdviewOperationalWidget = {
  Activities: 'activities',
  Attention: 'attention',
  Communication: 'communication',
  DocFlows: 'docFlows',
  Greta: 'greta',
  Properties: 'properties',
  ServiceRequests: 'serviceRequests',
}

export const BIRDVIEW_OPERATIONAL_WIDGET_TITLE_KEY = {
  [BirdviewOperationalWidget.Activities]:
    'DashboardBirdview.MyActivitiesTitleKey',
  [BirdviewOperationalWidget.Attention]: 'DashboardBirdview.AttentionTitleKey',
  [BirdviewOperationalWidget.Communication]:
    'DashboardBirdview.MyCommunicationsTitleKey',
  [BirdviewOperationalWidget.DocFlows]: 'DashboardBirdview.DocFlowsTitleKey',
  [BirdviewOperationalWidget.Greta]: 'DashboardBirdview.GretaTitleKey',
  [BirdviewOperationalWidget.Properties]:
    'DashboardBirdview.MyPropertiesTitleKey',
  [BirdviewOperationalWidget.ServiceRequests]:
    'DashboardBirdview.MyServiceRequestsTitleKey',
}

export const BIRDVIEW_OPERATIONAL_LAYOUT = {
  left: [
    BirdviewOperationalWidget.Activities,
    BirdviewOperationalWidget.ServiceRequests,
    BirdviewOperationalWidget.Properties,
    BirdviewOperationalWidget.DocFlows,
  ],
  right: [
    BirdviewOperationalWidget.Attention,
    BirdviewOperationalWidget.Communication,
    BirdviewOperationalWidget.Greta,
  ],
}

export const BIRDVIEW_OPERATIONAL_TILES = [
  {
    Icon: TaskIcon,
    key: BirdviewTileKey.Overdue,
    labelKey: 'DashboardBirdview.TileOverdueKey',
    sectionKey: BirdviewSection.TileOverdue,
    tone: DashboardTileTone.Success,
  },
  {
    Icon: ServiceRequestIcon,
    key: BirdviewTileKey.Input,
    labelKey: 'DashboardBirdview.TileNeedsMyInputKey',
    sectionKey: BirdviewSection.TileNeedsInput,
    tone: DashboardTileTone.Warning,
  },
  {
    Icon: EmailIcon,
    key: BirdviewTileKey.Unread,
    labelKey: 'DashboardBirdview.TileUnreadEmailsKey',
    sectionKey: BirdviewSection.TileUnread,
    tone: DashboardTileTone.Info,
  },
  {
    Icon: ProvidersIcon,
    key: BirdviewTileKey.NoProvider,
    labelKey: 'DashboardBirdview.TileWithoutProviderKey',
    sectionKey: BirdviewSection.TileNoProvider,
    tone: DashboardTileTone.Purple,
  },
]
